import React, { useEffect, useState, useRef } from 'react'
import { Tooltip } from "primereact/tooltip"

const parseDate = (dateString) => {
    const [day, month, yearAndTime] = dateString.split('.')
    const [year, time] = yearAndTime.split(' ')
    const [hours, minutes] = time.split(':')
    return new Date(parseInt(year), parseInt(month) - 1, parseInt(day), parseInt(hours), parseInt(minutes), 0)
}

const isWorkingDay = (date) => date.getDay() !== 0

const getWorkingHours = (date) => (date.getDay() === 6 ? { start: 10, end: 18 } : { start: 10, end: 19 })

const computeWorkingElapsedTime = (createdAt, now = new Date()) => {
    let totalMilliseconds = 0

    let currentTime = new Date(createdAt)

    while (currentTime < now) {
        if (isWorkingDay(currentTime)) {
            const { start, end } = getWorkingHours(currentTime)
            const startOfDay = new Date(currentTime).setHours(start, 0, 0, 0)
            const endOfDay = new Date(currentTime).setHours(end, 0, 0, 0)

            if (currentTime.getTime() < startOfDay) {
                currentTime.setHours(start, 0, 0, 0)
            } else if (currentTime.getTime() >= endOfDay) {
                currentTime.setDate(currentTime.getDate() + 1)
                currentTime.setHours(10, 0, 0, 0)
                continue
            }

            const timeLeft = Math.min(now.getTime(), endOfDay) - currentTime.getTime()
            totalMilliseconds += timeLeft
        }

        currentTime.setDate(currentTime.getDate() + 1)
        currentTime.setHours(10, 0, 0, 0)
    }

    return totalMilliseconds
}

const QueuedTimer = ({ createdAt, docLinkId }) => {
    const createdAtDate = useRef(parseDate(createdAt))
    const [totalElapsedTime, setTotalElapsedTime] = useState(computeWorkingElapsedTime(createdAtDate.current))

    useEffect(() => {
        const interval = setInterval(() => {
            const now = new Date()
            const totalElapseTime = computeWorkingElapsedTime(createdAtDate.current, now)
            setTotalElapsedTime(totalElapseTime)
        }, 1000)

        return () => clearInterval(interval)
    }, [])

    const formatElapsedTime = (milliseconds) => {
        const totalSeconds = Math.floor(milliseconds / 1000)
        const hours = Math.floor(totalSeconds / 3600)
        const minutes = Math.floor((totalSeconds % 3600) / 60)
        const seconds = totalSeconds % 60

        return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
    }

    return (
        <>
            <span
                className={`custom-tooltip-${docLinkId}`}
                style={{
                    color: totalElapsedTime < 60 * 60 * 1000 ? 'green' :
                        (totalElapsedTime <= 2 * 60 * 60 * 1000 ? 'darkorange' : 'red')
                }}
            >
                <b style={{ fontSize: '15px' }}>
                    {formatElapsedTime(totalElapsedTime)}
                </b>
            </span>

            {totalElapsedTime > 2 * 60 * 60 * 1000 && (
                <Tooltip target={`.custom-tooltip-${docLinkId}`} position="top" autoHide>
                    Deadline Passed: Action needed immediately to avoid further delays.
                </Tooltip>
            )}
        </>
    )
}

export default QueuedTimer
